import { defineComponent as _defineComponent } from 'vue'
import { Device } from '@/models/device';
import environment from '@/utils/environment';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceImage',
  props: {
    device: null,
    ratio: { default: '3by1' }
  },
  setup(__props: any) {

const props = __props as { device: Device, ratio: string };



const blobStorageName = computed<string>(() =>
  environment.getDataStorageBlobName(),
);

return { __sfc: true,props, blobStorageName }
}

})